module.exports = __webpack_public_path__ + "img/20210419210151550ty9.de29ff77.png";